/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { useIntl } from 'gatsby-plugin-react-intl';

import Layout from '../../Components/Core/Layout';
import SEO from '../../Components/Core/Seo';
import BlogScreen from '../../Components/Screens/Blog/BlogScreen';
import BackToTop from '../../Components/Core/BackToTop';
import { heroBanner } from '../../utils/variation';
import PageBuilder from '../../Components/Core/PageBuilder';
import BreadCrumbs from '../../Components/Custom/BreadCrumbs';

const BlogPage = ({ location, data }) => {
  const {
    contentfulPageLayout: {
      languageToggle,
      promoCode,
      topNotificationBanner,
      customHeader,
      customFooter,
      internal: { type },
      sections,
    },
  } = data;

  const intl = useIntl();

  const pageTemplate = {
    ...heroBanner,
    'blog-section': BlogScreen,
  };

  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      promoCode={promoCode}
      banner={topNotificationBanner}
      contentType={type}
    >
      <BreadCrumbs
        className="end-chevron"
        crumbs={[
          {
            label: `${intl.formatMessage({ id: 'learningHub' })}`,
            slug: '/learning-hub',
            active: true,
          },
        ]}
      />
      <PageBuilder sections={sections} template={pageTemplate} />
      <BackToTop />
    </Layout>
  );
};

BlogPage.propTypes = {
  location: PropTypes.shape().isRequired,
  data: PropTypes.shape().isRequired,
};

export const query = graphql`
  query BlogPageQuery($locale: String = "en-CA") {
    contentfulPageLayout(
      contentful_id: { eq: "2xIb4CVy45FMuySGCdAKgX" }
      node_locale: { eq: $locale }
    ) {
      contentful_id
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      promoCode
      internal {
        type
      }
      ...global_header
      ...global_footer
      ...notification_banners
      sections {
        ...hero_banner
        ...blog_section
      }
    }
  }
`;

export default BlogPage;

export const Head = ({ location, data, pageContext }) => {
  const schema = {
    '@context': 'https://schema.org/',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: `https://www.pcfinancial.ca/${pageContext.language}/`,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Learning Hub',
        item: `https://www.pcfinancial.ca/${pageContext.language}/learning-hub/`,
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Blog',
        item: `https://www.pcfinancial.ca${location.pathname}`,
      },
    ],
  };
  return (
    <SEO
      data={data.contentfulPageLayout}
      pageContext={pageContext}
      location={location}
    >
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </SEO>
  );
};
